
import { Result } from 'antd';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import './App.less';
// import './pages/doubleActivity/style.less';
import Home from './pages/home/index'
import About from './pages/home/about'
import Loading from './pages/components/Loading'
const Job = React.lazy(() => import("./pages/job"));
const Company = React.lazy(() => import("./pages/company"));
const DoubleActivity = React.lazy(() => import("./pages/doubleActivity"));
// const About = React.lazy(() => import("./pages/home/about"));

function App() {

  return (
    <Router>
      <Routes>
      <Route  path="/action/Common/index"
                   element={<Navigate to="/" replace={true} />}   //重定向到首页面
             />
        <Route path="/" element={<Home />} />
        <Route path="/home/about" element={<About />} />
        <Route path="/company/:id/:collegeId/:activeKey" element={<React.Suspense fallback={<Loading />}><Company /></React.Suspense>} />
        <Route path="/company/:id" element={<React.Suspense fallback={<Loading />}><Company /></React.Suspense>} />
        <Route path="/job/:id/:collegeId" element={<React.Suspense fallback={<Loading />}><Job /></React.Suspense>} />
        <Route path="/job/:id" element={<React.Suspense fallback={<Loading />}><Job /></React.Suspense>} />
        {/* <Route path="/doubleActivity" element={<React.Suspense fallback={<Loading />}><DoubleActivity /></React.Suspense>} /> */}
        <Route path="/doubleActivity/:activityId" element={<React.Suspense fallback={<Loading />}><DoubleActivity /></React.Suspense>} />
        <Route path="*" element={<Result
          status='success'
          title='404'
         
        />} />
      </Routes>
    </Router>
  )
}

export default App;
